import { useEffect } from "react"
import config from "../../config";

let firstLoad = false;

const files = {
  "jsFiles":[],
  "moduleFiles":["index.js"],
  "cssFiles":[
    "index.css"
  ]
}

function loadModuleScript(src) {
  return new Promise((resolve, reject) => {
    // prevent duplicate load
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve("already loaded");
      return;
    }


    const script = document.createElement("script");
    script.type = "module";
    script.crossOrigin = "anonymous";
    script.src = `${config.appkitPath}/${src}`;

    script.onload = () => resolve("loaded");
    script.onerror = () => reject(new Error("Failed to load script"));

    document.head.appendChild(script);
  });
}

function loadCss(href) {
  return new Promise((resolve, reject) => {
    // prevent duplicate load
    const existing = document.querySelector(`link[href="${href}"]`);
    if (existing) {
      resolve("already loaded");
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${config.appkitPath}/${href}?version=${config.version}`;

    link.onload = () => resolve("loaded");
    link.onerror = () =>
      reject(new Error(`Failed to load CSS: ${href}`));

    document.head.appendChild(link);
  });
}

function loadAssets(css, js) {
  return Promise.all([
    ...css.map(function(v){
        return loadCss(v);
    }),
    ...js.map(function(v){
        return loadModuleScript(v);
    }),
  ]);
}
  
const DivkitEditor = function(){
     useEffect(function(){
      if(!firstLoad) {
        firstLoad = true;
        loadAssets(files.cssFiles, files.moduleFiles).then(function(values){
          console.log(values);
        })
      }
    }, [])
    return <div className="divkit-wrapper w-100 h-100">
      <style>
        {`
        .save-button {
          pointer-events: none !important;
          opacity: 0.3;
        }
        `}
      </style>
      <div id="appkit-editor" className="w-100 h-100"></div>
    </div>
}

export default DivkitEditor